import { apiFetch } from '@/api/http';

export async function signHashWithFounderKey(hashHex: string): Promise<string> {
  const clean = hashHex.startsWith('sha256:') ? hashHex.slice(7) : hashHex;
  const data = await apiFetch<{ signature: string }>('/admin/founder/sign-hash', {
    method: 'POST',
    body: { hash_hex: clean },
    // /admin/founder/sign-hash is a Founder-gated mutation (require_founder),
    // so every POST must carry the anti-injection phrase. Without it the sign
    // call 400s before any signed action (reject / approve) can proceed.
    headers: { 'X-Omega-Confirm': 'GI-OMEGA-SHALEV-2026' },
  });
  return data.signature;
}
